import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class ReformsService {
  env = environment.env;
  maintenanceReformsURL = endpointsURL.maintenanceReformsURL;

  constructor(private httpClient: HttpClient) {}

  public lista(filters: string): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceReformsURL}list?${filters}`
    );
  }
  public createReform(reform: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.maintenanceReformsURL}edit`,
      reform
    );
  }
  public getReform(idReform: string): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceReformsURL}edit/${idReform}`
    );
  }
  public updateReform(reform: any): Observable<any> {
    const fd = new FormData();
    if (
      reform.ayudaEspanolDto.ayAyuda == null ||
      reform.ayudaEspanolDto.ayAyuda.length == 0
    ) {
      fd.append("fileEs", new Blob([], { type: "text/html" }));
    } else {
      fd.append("fileEs", reform.ayudaEspanolDto.ayAyuda);
    }
    if (
      reform.ayudaInglesDto.ayAyuda == null ||
      reform.ayudaInglesDto.ayAyuda.length == 0
    ) {
      fd.append("fileEn", new Blob([], { type: "text/html" }));
    } else {
      fd.append("fileEn", reform.ayudaInglesDto.ayAyuda);
    }

    reform.ayudaEspanolDto.ayAyuda = null;
    reform.ayudaInglesDto.ayAyuda = null;
    fd.append("maintenanceReformasDto", JSON.stringify(reform));
    return this.httpClient.put<any>(
      `${this.env}${this.maintenanceReformsURL}edit/${reform.reforma.reId}`,
      fd
    );
  }
  public deleteReform(idReform: string): Observable<any> {
    return this.httpClient.delete(
      `${this.env}${this.maintenanceReformsURL}edit/${idReform}`
    );
  }
  public getInfoRelatedToReform(idReform: string): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceReformsURL}getInfo/${idReform}`
    );
  }

  public downloadAyudaFile(idFichero: number) {
    return this.httpClient.get(
      `${this.env}${this.maintenanceReformsURL}edit/download/${idFichero}`,
      { responseType: "blob" }
    );
  }
}
